<template>
	<div class="webContent flex">
		<div class="mine" :class="{ ts_mine: $h5Power=='instructor'||$h5Power=='teacher' }">
			<div class="area">
				<div class="user df hao">
					<div class="user-left">
						<div class="uname">{{user}}</div>
						<div class="point">
							<img src="../../../assets/point2.png" style="width:.11rem;height:.15rem"/>
							<span class="point-tip">积分</span>
							<span>|</span>
							<span class="point-tip">{{point}}</span>
						</div>
					</div>
					<div class="jifenbang" @click="toJifenbang">
						<img src="../../../assets/h5-jifen.png" style="width:.15rem;height:.16rem;margin-right:.04rem"/>
						<span>积分榜</span>
					</div>
					<!-- <div class="unset">退出登录</div> -->
				</div>
				<div class="social2" v-if="$h5Power=='instructor'||$h5Power=='teacher'">
					<div class="uduty">{{duty}}</div>
					<div class="socialLine df hao">
						<div class="socialLi"><em>{{followCount2}}</em>关注我的人</div>
						<div class="socialLi"><em>{{followCount}}</em>我关注的人</div>
					</div>
					<div class="socialLine2 df hao">
						<div class="socialLi socialLi2">得到<em>{{likeCount}}</em>点赞</div>
						<div class="socialLi socialLi3">已被<em>{{collectCount}}</em>次收藏</div>
					</div>
				</div>
				<div class="social df hao" v-else>
					<div class="socialLi"><em>{{followCount}}</em>关注的人</div>
					<div class="socialLi socialLi2">得到<em>{{likeCount}}</em>点赞</div>
				</div>
				<div class="model df hao">
					<div class="modelLi flex df cf wao hao" :class="{ cur: chooseModel=='ask' }" @click="tabModel('ask')"><b>{{model.ask}}</b>问题</div>
					<div class="modelLi flex df cf wao hao" :class="{ cur: chooseModel=='follow' }" @click="tabModel('follow')"><b>{{model.follow}}</b>{{$h5Power=='instructor'||$h5Power=='teacher'?'关注':'我关注的'}}</div>
					<div class="modelLi flex df cf wao hao" :class="{ cur: chooseModel=='collect' }" @click="tabModel('collect')"><b>{{model.collect}}</b>收藏夹</div>
					<div class="modelLi flex df cf wao hao" :class="{ cur: chooseModel=='browse' }" @click="tabModel('browse')"><b>{{model.browse}}</b>最近浏览</div>
				</div>
			</div>

			<!-- 问题 -->
			<div class="content" v-show="chooseModel=='ask'">
				<div class="nav df hao" v-if="$h5Power=='instructor'||$h5Power=='teacher'">
					<div class="navLi flex" :class="{ cur: chooseNav=='proposeAsk' }" @click="tabNav('proposeAsk')">我提出的问题</div>
					<div class="navLi flex" :class="{ cur: chooseNav=='proposeAns' }" @click="tabNav('proposeAns')">我回答的问题</div>
					<div class="navLi flex" :class="{ cur: chooseNav=='followAsk' }" @click="tabNav('followAsk')">我关注的问题</div>
				</div>
				<div class="nav df hao" v-else>
					<div class="navLi flex" :class="{ cur: chooseNav=='proposeAsk' }" @click="tabNav('proposeAsk')">我提出的问题</div>
					<div class="navLi flex" :class="{ cur: chooseNav=='followAsk' }" @click="tabNav('followAsk')">我关注的问题</div>
				</div>
				<!-- 我提出的问题 -->
				<div class="list" v-show="chooseNav=='proposeAsk'" @scroll="listenScroll_proposeAsk">
					<div class="li df hao" v-for="(v,i) in proposeAskList" :key="i" @click="toDetail(v)">
						<div class="lt flex">
							<div class="title ov-d">{{v.title}}</div>
							<div class="tool df">
								<div class="flex">{{dateTime(v.createTime)}} · {{v.answerTotal>0?v.answerTotal+'人回答':'暂无回答'}} · {{v.attentionTotal>0?v.attentionTotal+'人关注':'暂无关注'}}</div>
							</div>
						</div>
						<div class="state" v-if="v.status==2">审核驳回</div>
						<div class="state state2" v-if="v.status==1">审核通过</div>
						<div class="state state3" v-if="v.status==0">正在审核</div>
						<div class="state state4" v-if="v.status==255">已被删除</div>
					</div>
				</div>
				<!-- 我回答的问题 -->
				<div class="list" v-show="chooseNav=='proposeAns'" @scroll="listenScroll_proposeAns">
					<div class="li df hao" v-for="(v,i) in proposeAnsList" :key="i" @click="toDetail(v)">
						<div class="lt flex">
							<div class="title ov-d">{{v.title}}</div>
							<div class="tool df">
								<div class="flex">{{dateTime(v.createTime)}} · {{v.answerTotal>0?v.answerTotal+'人回答':'暂无回答'}} · {{v.attentionTotal>0?v.attentionTotal+'人关注':'暂无关注'}}</div>
							</div>
						</div>
						<div class="state" v-if="v.status==2">审核驳回</div>
						<div class="state state2" v-if="v.status==1">审核通过</div>
						<div class="state state3" v-if="v.status==0">正在审核</div>
						<div class="state state4" v-if="v.status==255">已被删除</div>
					</div>
				</div>
				<!-- 我关注的问题 -->
				<div class="list" v-show="chooseNav=='followAsk'" @scroll="listenScroll_followAsk">
					<div class="li df hao" v-for="(v,i) in followAskList" :key="i" @click="toDetail(v)">
						<div class="lt flex">
							<div class="title">{{v.title}}</div>
							<div class="tool df">
								<div class="flex">{{dateTime(v.createTime)}} · {{v.answerTotal>0?v.answerTotal+'人回答':'暂无回答'}} · {{v.attentionTotal>0?v.attentionTotal+'人关注':'暂无关注'}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 关注 -->
			<div class="content" v-show="chooseModel=='follow'">
				<div class="nav df hao" v-if="$h5Power=='instructor'||$h5Power=='teacher'">
					<div class="navLi flex" :class="{ cur: chooseNav2=='meFollow' }" @click="tabNav2('meFollow')">我关注的人</div>
					<div class="navLi flex" :class="{ cur: chooseNav2=='followMe' }" @click="tabNav2('followMe')">关注我的人</div>
				</div>
				<!-- 我关注的人 -->
				<div class="list2" v-show="chooseNav2=='meFollow'" @scroll="listenScroll_follow">
					<div class="li2 df hao" v-for="(v,i) in followList" :key="i" @click="toFollowUser(v,true)">
						<div class="lt flex">
							<div class="uname2">{{v.name}}</div>
							<div class="duty">{{v.mapperNumber}}</div>
						</div>
						<div class="state state2" @click.stop.prevent="showCancelFollow(v,1)">已关注</div>
					</div>
				</div>
				<!-- 关注我的人 -->
				<div class="list2" v-show="chooseNav2=='followMe'" @scroll="listenScroll_follow2">
					<div class="li2 df hao" v-for="(v,i) in followList2" :key="i" @click="toFollowUser(v,v.attentionId)">
						<div class="lt flex">
							<div class="uname2">{{v.name}}</div>
							<div class="duty" v-if="v.post!=''">{{v.post}}</div>
						</div>
						<div class="state state2" @click.stop.prevent="showCancelFollow(v,2)" v-if="v.attentionId">已关注</div>
						<div class="state" @click.stop.prevent="followUser(v.userId,v)" v-else>关注</div>
					</div>
				</div>
			</div>

			<!-- 收藏夹 -->
			<div class="search df hao" v-show="chooseModel=='collect'">
				<input type="text" puc class="flex" placeholder="在收藏夹内搜索" v-model="collectKeyword" />
				<div class="btn" @click="searchCollect"></div>
			</div>
			<div class="content" v-show="chooseModel=='collect'">
				<div class="list3">
					<div class="li3 df hao" v-for="(v,i) in collectList" :key="i" @click="toCollectList(v)">
						<div class="lt flex">
							<div class="title ov-d">{{v.name}}</div>
							<div class="tool">{{(v.answerTotal+v.questionsTotal)}}个内容</div>
						</div>
						<div class="edit" @click.stop.prevent="showCollectAddBase(v)"></div>
					</div>
				</div>
			</div>

			<!-- 最近浏览 -->
			<div class="list4" v-show="chooseModel=='browse'" @scroll="listenScroll_browse">
				<div class="li4" v-for="(v,i) in browseList" :key="i">
					<div class="cap">{{v.day}}</div>
					<div class="item" v-for="(v2,i2) in v.item" :key="i2" @click="toDetail(v2)">
						<div class="title">{{v2.title}}</div>
						<div class="tool">{{v2.date}} · {{v2.answerCount>0?v2.answerCount+'人回答':'暂无回答'}} · {{v2.followCount>0?v2.followCount+'人关注':'暂无关注'}}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 修改收藏夹 -->
		<div class="collectAddBase df wao hao" v-if="collectAddBase.has">
			<div class="collectAddBase-box">
				<div class="collectAddBase-input df hao">
					<input type="text" puc class="flex" placeholder="输入收藏夹标题" v-model="collectAddBase.val" @input="checkInput" />
					<i>{{13-collectAddBase.val.length}}</i>
				</div>
				<div class="collectAddBase-end df war hao">
					<div class="collectAddBase-btn" @click="resCollectAddBase">确认</div>
					<div class="collectAddBase-btn" @click="closeCollectAddBase">取消</div>
				</div>
			</div>
		</div>

		<!-- 取消关注 -->
		<div class="cancelFollow df wao hao" v-if="cancelFollow.has">
			<div class="cancelFollow-box">
				<div class="cancelFollow-txt">确认不再关注<em>{{cancelFollow.user}}</em>吗？</div>
				<div class="cancelFollow-end df war hao">
					<div class="cancelFollow-btn" @click="closeCancelFollow">放弃</div>
					<div class="cancelFollow-btn" @click="resCancelFollow">取消关注</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import h5PublicApi from '../../../script/public.js'

	let follow_nav = '';
	let follow_obj = null;

	export default {
		name: 'me_index_page',
		data () {
			return {
				user: '',
				duty: '',
				point: 0,
				followCount: 0, // 我关注的人
				followCount2: 0, // 关注我的人
				likeCount: 0, // 被点赞总数
				collectCount: 0, // 被收藏总数
				model: {
					ask: 0, // 问题总数
					follow: 0, // 关注人+被人关注的总数
					collect: 0, // 收藏夹总数
					browse: 0, // 浏览总数
				},
				chooseModel: h5PublicApi.tabNavTed('get','meIndexModel','ask'),
				chooseNav: h5PublicApi.tabNavTed('get','meIndexNav','proposeAsk'),
				chooseNav2: h5PublicApi.tabNavTed('get','meIndexNav2','meFollow'),
				pagenum_proposeAsk: 1,
				pagesize_proposeAsk: 10,
				state_proposeAsk: false,
				proposeAskList: [],
				pagenum_proposeAns: 1,
				pagesize_proposeAns: 10,
				state_proposeAns: false,
				proposeAnsList: [],
				pagenum_followAsk: 1,
				pagesize_followAsk: 10,
				state_followAsk: false,
				followAskList: [],
				pagenum_follow: 1,
				pagesize_follow: 10,
				state_follow: false,
				followList: [],
				pagenum_follow2: 1,
				pagesize_follow2: 10,
				state_follow2: false,
				followList2: [],
				collectKeyword: '',
				collectList: [],
				pagenum_browse: 1,
				pagesize_browse: 10,
				state_browse: false,
				browseDate: {},
				browseList: [],
				collectAddBase: {
					has: false,
					id: '',
					val: '',
				},
				cancelFollow: {
					has: false,
					id: '',
					user: '',
				},
			}
		},
		mounted(){
			// 获取登录用户详细信息
			this.h5Ajax('get','$/user/info',{}).then(r=>{
				this.user = r.name;
				this.duty = r.post;
				this.point = r.integration;
			}).catch(err => {
				console.error('err:' + err)
			})

			// 查询当前登录用户的统计数据
			this.getCountData();

			// 获取我提出的问题
			this.getList_proposeAsk();

			// 获取我回答的问题
			this.getList_proposeAns();

			// 获取我关注的问题
			this.getList_followAsk();

			// 获取我关注的人
			this.getList_follow();

			// 获取关注我的人
			this.getList_follow2();

			// 获取收藏夹
			this.getList_collect();

			// 获取最近浏览
			this.getList_browse();

			h5PublicApi.tabNavTed('set','homeType','');
			h5PublicApi.tabNavTed('set','messageIndexModel','');
			h5PublicApi.tabNavTed('set','messageIndexNav','');
			h5PublicApi.tabNavTed('set','messageIndexNav2','');
			h5PublicApi.tabNavTed('set','adminIndexModel','');
		},
		methods: {
			toJifenbang(){
				this.$router.replace({ path: '/model/league' });
			},
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			getDate(type){
				if(type=='yesterday'){
					var date = new Date( new Date().getTime()-24*60*60*1000 );
				}else{
					var date = new Date();
				}

				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			tabModel(model){
				this.chooseModel = model;
				h5PublicApi.tabNavTed('set','meIndexModel',model)
			},
			tabNav(nav){
				this.chooseNav = nav;
				h5PublicApi.tabNavTed('set','meIndexNav',nav)
			},
			tabNav2(nav){
				this.chooseNav2 = nav;
				h5PublicApi.tabNavTed('set','meIndexNav2',nav)
			},
			getCountData(){
				this.h5Ajax('get','$/user/findUserCount',{}).then(r=>{
					this.followCount = r.attentionUserTotal||0; // 我关注的人
					this.followCount2 = r.userConcernedTotal||0; // 关注我的人
					// this.likeCount = r.userApprovaledTotal||0; // 被点赞总数
					this.likeCount = (r.answerApprovaledTotal||0)+(r.questionApprovaledTotal||0)+(r.userApprovaledTotal||0); // 被点赞总数(发表的答案被点赞总数+发表的问题被点赞总数+个人被点赞总数)
					// this.collectCount = r.userFavoritedTotal||0; // 被收藏总数
					this.collectCount = (r.answerFavoritedTotal||0)+(r.questionFavoritedTotal||0)+(r.userFavoritedTotal||0); // 被收藏总数(发表的答案被收藏总数+发表的问题被收藏总数+个人被收藏总数)
					this.model.ask = r.questionsTotal||0; // 问题总数
					this.model.follow = (r.attentionUserTotal||0)+(r.userConcernedTotal||0); // 关注人+被人关注的总数
					this.model.collect = r.favoritesTotal||0; // 收藏夹总数
					this.model.browse = r.browsesTotal||0; // 浏览总数
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_proposeAsk(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_proposeAsk();
				}
			},
			addMoreData_proposeAsk() { //加载更多
				if(this.state_proposeAsk){
					return false;
				}
				this.pagenum_proposeAsk ++;
				this.getList_proposeAsk();
			},
			getList_proposeAsk(){
				this.state_proposeAsk = true;

				this.h5Ajax('get','$/questions/listByUser',{
					page: this.pagenum_proposeAsk,
					size: this.pagesize_proposeAsk,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.proposeAskList.push(d);
						}
						this.state_proposeAsk = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_proposeAns(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_proposeAns();
				}
			},
			addMoreData_proposeAns() { //加载更多
				if(this.state_proposeAns){
					return false;
				}
				this.pagenum_proposeAns ++;
				this.getList_proposeAns();
			},
			getList_proposeAns(){
				this.state_proposeAns = true;

				this.h5Ajax('get','$/questions/answerQuestions',{
					page: this.pagenum_proposeAns,
					size: this.pagesize_proposeAns,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.proposeAnsList.push(d);
						}
						this.state_proposeAns = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_followAsk(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_followAsk();
				}
			},
			addMoreData_followAsk() { //加载更多
				if(this.state_followAsk){
					return false;
				}
				this.pagenum_followAsk ++;
				this.getList_followAsk();
			},
			getList_followAsk(){
				this.state_followAsk = true;

				this.h5Ajax('get','$/questions/attention',{
					page: this.pagenum_followAsk,
					size: this.pagesize_followAsk,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.followAskList.push(d);
						}
						this.state_followAsk = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_follow(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_follow();
				}
			},
			addMoreData_follow() { //加载更多
				if(this.state_follow){
					return false;
				}
				this.pagenum_follow ++;
				this.getList_follow();
			},
			getList_follow(){
				this.state_follow = true;

				this.h5Ajax('get','$/user/attentionUsers',{
					page: this.pagenum_follow,
					size: this.pagesize_follow,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.followList.push(d);
						}
						this.state_follow = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_follow2(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_follow2();
				}
			},
			addMoreData_follow2() { //加载更多
				if(this.state_follow2){
					return false;
				}
				this.pagenum_follow2 ++;
				this.getList_follow2();
			},
			getList_follow2(){
				this.state_follow2 = true;

				this.h5Ajax('get','$/user/usersAttention',{
					page: this.pagenum_follow2,
					size: this.pagesize_follow2,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.followList2.push(d);
						}
						this.state_follow2 = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			searchCollect(){
				this.getList_collect(this.collectKeyword);
			},
			getList_collect(keyword){
				this.h5Ajax('get','$/favorites/listByUid',{
					personal: 0,
				}).then(r=>{
					if(keyword==undefined){
						this.collectList = r;
					}else{
						this.collectList = [];
						r.forEach((v,i)=>{
							if(v.name.indexOf(keyword)>=0){
								this.collectList.push(v);
							}
						})
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_browse(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_browse();
				}
			},
			addMoreData_browse() { //加载更多
				if(this.state_browse){
					return false;
				}
				this.pagenum_browse ++;
				this.getList_browse();
			},
			getList_browse(){
				this.state_browse = true;

				var nowDate = this.getDate();
				var yesterday = this.getDate('yesterday');

				this.h5Ajax('get','$/questions/browses',{
					page: this.pagenum_browse,
					size: this.pagesize_browse,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];

							var date = this.dateTime(d.createTime);
							var dateGroup = date;
							if(date==nowDate){
								dateGroup = '今天';
							}else if(date==yesterday){
								dateGroup = '昨天';
							}

							var k = {
								id: d.id,
								title: d.title,
								answerCount: d.answerTotal,
								followCount: d.attentionTotal,
								date: date,
							};

							if(this.browseDate[dateGroup]==undefined){
								this.browseDate[dateGroup] = this.browseList.length;
								this.browseList.push({
									day: dateGroup,
									item: [k],
								});
							}else{
								var index = this.browseDate[dateGroup];
								this.browseList[index].item.push(k);
							}
						}
						this.state_browse = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			showCollectAddBase(data){
				this.collectAddBase = {
					has: true,
					id: data.id,
					val: data.name,
				}
			},
			closeCollectAddBase(){
				this.collectAddBase.has = false;
			},
			resCollectAddBase(){
				this.h5Ajax('post','$/favorites/modifyName',{
					id: this.collectAddBase.id,
					name: this.collectAddBase.val,
					personal: 0,
				}).then(r=>{
					this.collectAddBase.has = false;
					this.getList_collect();
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			checkInput(){
				if(this.collectAddBase.val.length>13){
					this.collectAddBase.val = this.collectAddBase.val.substring(0,13);
				}
			},
			followUser(id,item){
				this.h5Ajax('post','$/attentions/add',{
					attentionId: id,
					types: 3,
				}).then(r=>{
					this.pagenum_follow = 1;
					this.state_follow = false;
					this.followList = [];
					this.getList_follow();
					// this.pagenum_follow2 = 1;
					// this.state_follow2 = false;
					// this.followList2 = [];
					// this.getList_follow2();
					item.attentionId = r.id;
					this.getCountData();
				})
			},
			showCancelFollow(data,nav){
				follow_nav = (nav==1?'followList':'followList2');
				follow_obj = data;
				this.cancelFollow = {
					has: true,
					id: data.attentionId,
					user: data.name,
				};
			},
			closeCancelFollow(){
				this.cancelFollow.has = false;
			},
			resCancelFollow(){
				this.h5Ajax('post','$/attentions/cancel',{
					id: this.cancelFollow.id,
				}).then(r=>{
					this.cancelFollow.has = false;

					// this.pagenum_follow = 1;
					// this.state_follow = false;
					// this.followList = [];
					// this.getList_follow();
					// this.pagenum_follow2 = 1;
					// this.state_follow2 = false;
					// this.followList2 = [];
					// this.getList_follow2();
					if(follow_nav=='followList'){
						let remove_index = null;
						this.followList.forEach((v,i)=>{
							if(v.userId==follow_obj.userId){
								remove_index = i;
							}
						})
						if(remove_index!=null){
							this.followList.splice(remove_index,1);
						}

						let remove_index2 = null;
						this.followList2.forEach((v,i)=>{
							if(v.userId==follow_obj.userId){
								remove_index2 = i;
							}
						})
						if(remove_index2!=null){
							this.followList2[remove_index2].attentionId = 0;
						}
					}else if(follow_nav=='followList2'){
						this.pagenum_follow = 1;
						this.state_follow = false;
						this.followList = [];
						this.getList_follow();

						follow_obj.attentionId = 0;
					}
					this.getCountData();
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			toFollowUser(data,isFollow){
				this.$router.replace({ path: '/me/user', query: { id: data.userId } });
			},
			toCollectList(data){
				this.$router.replace({ path: '/me/collectList', query: { id: data.id, name: data.name } });
			},
			toDetail(data){
				this.$router.replace({ path: '/model/detail', query: { id: data.id } });
			},
		},
	}
</script>

<style scoped>
	@import './index';
</style>



// WEBPACK FOOTER //
// src/app/pages/me/index/index.vue